import { useEffect } from "react";

import ClientDetailProvider from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/context/ClientDetailContext";
import ProviderListv2Wrapper from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/ProviderListv2/ProviderListv2Wrapper";
import Navigation from "../../../../../components/navigations/client/detail/medical/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/medical/providers");
  }, []);

  return (
    <Navigation activeTab="providers" _case={_case}>
      <ClientDetailProvider>
        <ProviderListv2Wrapper caseInfo={_case} />
      </ClientDetailProvider>
    </Navigation>
  );
};
